import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const useIdleLogout = (idleTime = 20 * 60 * 1000) => {
  const navigate = useNavigate();
  const idleTimer = useRef<NodeJS.Timeout | null>(null);

  const resetIdleTimer = () => {
    if (idleTimer.current) {
      clearTimeout(idleTimer.current);
    }

    idleTimer.current = setTimeout(() => {
      handleLogout();
    }, idleTime);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/');
  };

  const activityEvents = ['mousemove', 'keydown', 'mousedown', 'touchstart'];

  useEffect(() => {
    const userDetailsString = sessionStorage.getItem('userDetails');
    const userDetailsJson = userDetailsString ? JSON.parse(userDetailsString) : null;
    const token = userDetailsJson?.token;

    if (!token || token.trim() === '') {
      handleLogout();
    } else {
      activityEvents.forEach(event => window.addEventListener(event, resetIdleTimer));
      resetIdleTimer();
    }

    return () => {
      if (idleTimer.current) {
        clearTimeout(idleTimer.current);
      }
      activityEvents.forEach(event => window.removeEventListener(event, resetIdleTimer));
    };
  }, []);

  return null;
};

export default useIdleLogout;
